
import { Link } from "react-router-dom";

function Footer() {
  return (
    <>
      <section className="footer ps position-relative">
        <div className="container">
          <div className="row     align-items-center">
            <div className="col-md-4 col-lg-3 ms-auto order-md-2">
              <ul className="nav_link">
                <li>
                   
                  <Link to="/casestudies" className="">
                    <i className="bi bi-chevron-right me-3" /> Case studies
                  </Link>
                </li>
                <li>  
                  <Link to="/research" className="">
                    <i className="bi bi-chevron-right me-3" /> Research
                  </Link> 
                </li>
                <li>  
                  <Link to="/plan" className="">
                    <i className="bi bi-chevron-right me-3" /> Plans
                  </Link> 
                </li>
                {/* <li> 
                  <a className href="#">
                    <i className="bi bi-chevron-right me-3" /> Store
                  </a>
                </li> */}
              </ul>
            </div>
            <div className="col-md-6 col-lg-7 order-md-1 mt-5 col-11 mt-md-0">
              <img src="/assets/img/big_logo.svg" alt="logo" className="img-fluid logo_dark" />
              <img src="/assets/img/big_logo-light.svg" alt="logo" className="img-fluid logo_light" />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Footer;
